import { jdiColorFetch } from '@/apis/colorFetchV2';
import { dataExpTagConfig } from '@/components/product/const';
import { EXPOSURE_RECORD } from '@/tracks/25217';
import { useEffect, useState } from 'react';
import DetailContent from './detailContent';
import styles from './index.module.scss';

type Props = {
  serviceItemId?: string;
  mainskuid: string;
};

export default function ServiceDetail({ serviceItemId, mainskuid }: Props) {
  const [serviceDetail, setServiceDetail] = useState();

  useEffect(() => {
    const fetchData = async () => {
      if (!serviceItemId) {
        return;
      }
      const serviceDetailData = await jdiColorFetch('trade_item_getDescription', {
        bodyQuery: {
          verticalTag: 'cn_ybxt_b2c',
          skuId: serviceItemId,
          uniformBizInfo: { tenantId: 1, buId: 405, channelId: 0, ua: 4 },
        },
        next: {
          revalidate: 5,
        },
      });
      if (serviceDetailData) {
        setServiceDetail(serviceDetailData);
      }
    };
    fetchData();
  }, [serviceItemId]);

  return (
    <div
      exptag={'exp|' + EXPOSURE_RECORD.Productdetail_AdditionalServiceDetails_Expo}
      data-exptag-config={dataExpTagConfig}
      data-exptag-json-param={JSON.stringify({
        mainskuid,
        serviceFloorBuryPoint: JSON.stringify({ skuid: serviceItemId }),
      })}
      className={styles.serviceDetailWrap}
    >
      <DetailContent detailData={serviceDetail} />
    </div>
  );
}
